/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { toHeaderCase } from 'js-convert-case';
import config from '../config/featuresSection.config.json';
import moment from 'moment';

export interface IFormatPolicyDetailMethods extends IPluginMethodMap {
  getFormatPolicyDetailSync(args: any): any;
}

const lookup = require('country-code-lookup');

export class FormatPolicyDetailService implements IAgentPlugin {
  readonly methods: IFormatPolicyDetailMethods;

  constructor() {
    this.methods = {
      getFormatPolicyDetailSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      policyId: args?.id,
      title: args?.name,
      premium: args?.premium,
      subTitle: args?.description,
      minDue: args?.minDue,
      listItems: this.getListItems(args),
      carouselItems: this.getCarouselItems(args?.doc),
      heroImage: {
        image: args?.icon,
      },
    };
  }

  private getCarouselItems(doc: any) {
    let _temp = [];
    if (doc) {
      _temp.push({
        type: 'pdf',
        poster: doc,
        src: doc,
        title: 'Document',
      });
    }
    return _temp;
  }

  private getAccordionItems(res: any) {
    let items: any = [];
    let _policyHolder = this.getPolicyDetails(res);
    if (res?.description) {
      items.push({
        type: 'text',
        title: 'Description',
        data: [res?.description],
      });
    }
    if (_policyHolder) {
      items?.push({
        type: 'multi-col-list',
        numberOfColumns: '3',
        title: _policyHolder?.title,
        data: [..._policyHolder?.listItems],
      });
    }
    if (res?.benificiaryDetail) {
      let _temp = this.getBeneficiary(res?.benificiaryDetail);
      items.push({
        type: 'multi-col-list',
        numberOfColumns: '3',
        title: _temp?.title,
        data: [..._temp?.listItems],
      });
    }

    let _useOfProceeds = this.getUseOfProceeds(res);
    if (_useOfProceeds) {
      items.push({
        type: 'check-list',
        title: _useOfProceeds?.title,
        data: [..._useOfProceeds?.listItems],
      });
    }
    return items;
  }

  private getListItems(res: any) {
    console.log('payments', res);

    let _temp: any = [];
    _temp = config?.listItems?.map((ele: any) => {
      if (ele?.key === 'validFrom') {
        return {
          ...ele,
          subTitle: this.formatCreatedDate(res?.validFrom),
        };
      }
      if (ele?.key === 'validUntil') {
        return {
          ...ele,
          subTitle: this.formatCreatedDate(res?.validUntil),
        };
      }
    });

    return _temp;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    } else {
      return '';
    }
  }

  private getBeneficiary(res: any) {
    let _beneficiary = {
      firstName: res?.firstName,
      lastName: res?.lastName,
      email: res?.email,
      phoneNumber: res?.mobileNo,
      streetAddress: res?.address?.addressLine1,
      city: res?.address?.city,
      country:
        res?.address?.country && res?.address?.country.length === 2
          ? lookup.byIso(`${res?.address?.country}`)?.country
          : '-',
    };
    let _temp = [];
    for (const [key, value] of Object.entries(_beneficiary)) {
      _temp.push({
        title: toHeaderCase(key),
        subTitle: value,
      });
    }
    return {
      title: config?.beneficiaryDetails?.title,
      listItems: _temp,
    };
  }
  private getPolicyDetails(res: any) {
    let _temp = [
      {
        title: 'Policy Number',
        subTitle: res?.policyNumber,
      },
      {
        title: 'Policy Option',
        subTitle: `Policy Option ${res?.productDefination}`,
      },
      {
        title: 'Coverage Amount',
        subTitle: res?.coverage,
      },
      {
        title: 'Annual Premium',
        subTitle: res?.premium,
      },
      {
        title: 'Purchase on',
        subTitle: moment(res?.purchasedAt).format('DD/MM/YYYY'),
      },
      {
        title: 'Policy Type',
        subTitle: toHeaderCase(res?.type ?? '-'),
      },
      {
        title: 'Insured Country',
        subTitle: res?.countryToBeInsured
          ? lookup.byIso(`${res?.countryToBeInsured}`)?.country
          : '-',
      },
    ];
    return {
      title: config?.policyDetails?.title,
      listItems: _temp,
    };
  }

  private getUseOfProceeds(data: any) {
    let _temp: any = [];
    Array.isArray(data?.useOfProceeds) &&
      data?.useOfProceeds?.forEach((element: any) => {
        if (element.selected) {
          _temp.push(toHeaderCase(element?.value ?? ''));
        }
      });

    return {
      title: config?.useOfProceedsDetail?.title,
      listItems: _temp,
    };
  }
}
